import type { FieldRootProps } from '@chakra-ui/react';
import { Spinner } from '@chakra-ui/react';
import { AsyncStatus } from '@monetize/types/common';
import { AsyncStatusIndicator, MBox } from '../../../components/Monetize';
import { MCustomSelect } from '../../../components/Monetize/MCustomSelect/MCustomSelect';
import { SettingsControl } from './SettingsControl';

interface SelectItem {
  value: string;
  label: string;
}

interface SettingsSelectProps {
  name: string;
  heading: string;
  subheading?: string;
  fetchLoading?: boolean;
  value: string;
  items: SelectItem[];
  isDisabled?: boolean;
  asyncStatus?: AsyncStatus;
  formControlProps?: FieldRootProps;
  onChange: (value: string) => void | Promise<unknown>;
}

export const SettingsSelect = ({
  name,
  heading,
  subheading,
  fetchLoading = false,
  value,
  items,
  formControlProps,
  isDisabled = false,
  asyncStatus = 'idle',
  onChange,
}: SettingsSelectProps) => {
  const control = fetchLoading ? (
    <Spinner size="md" />
  ) : (
    <MBox position="relative" minW="200px">
      <MCustomSelect
        name={name}
        items={items}
        itemTitle="label"
        itemValue="value"
        value={value}
        isDisabled={isDisabled || asyncStatus === 'loading'}
        onChange={(val) => onChange(val as string)}
        inputProps={{ id: name, 'aria-describedby': `${name}-subheading` }}
      />
      <AsyncStatusIndicator status={asyncStatus} />
    </MBox>
  );

  return (
    <SettingsControl
      name={name}
      heading={heading}
      subheading={subheading}
      fetchLoading={fetchLoading}
      isDisabled={isDisabled || asyncStatus === 'loading'}
      formControlProps={formControlProps}
      control={control}
    />
  );
};
